export const styles = () => ({
  container: {
    padding: '0 10px',
  },
  errorLabel: {
    color: 'red',
  },
});
